export default __webpack_public_path__ + "static/media/RistekLogo-light.b1a31b80.svg";